import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(ScrollTrigger);

const paths = {
  "1a": "M13.5 58.5C15.5 22 8.5 9.4 0.5 1",
  "1b": "M38.5 45C30.5 36.5 8.5 23.8 0.5 1",
  "2a": "M1.49998 51.5C1.16665 40.5 2.89998 14.9 12.5 0.5",
  "2b": "M1 50C4.66667 42.8333 15.8 27.3 31 22.5C46.2 17.7 53.3333 6.16667 55 1",
  "3a": "M0.5 26.5V0.5",
  "3b": "M1 63.5C2.5 49.1667 8.7 16.5 21.5 0.5",
};

const createElements = (wrapper) => {
  const birds = [];
  const birdsEl = document.createElement("div");
  birdsEl.className = "birds-wrapper";
  for (let i = 0; i < 3; i++) {
    const bird = document.createElement("div");
    bird.className = "bird";
    birds.push(bird);
    birdsEl.appendChild(bird);
  }

  wrapper.prepend(birdsEl);

  return birds;
};

const animate = (bird, path, scale, opacity) => {
  gsap.to(bird, {
    duration: 0.4,
    opacity,
    scale,
    motionPath: {
      path,
      autoRotate: 90,
      align: "self",
    },
    ease: "power1.inOut",
  });
};

const animateIn = (birds) => {
  gsap.killTweensOf(birds);
  gsap.set(birds, { clearProps: "all" });
  animate(birds[0], paths["1a"], 1.6, 0.2);
  animate(birds[1], paths["2a"], 1, 0.5);
  animate(birds[2], paths["3a"], 1, 1);
};

const animateOut = (birds) => {
  animate(birds[0], paths["1b"], 1.6, 0);
  animate(birds[1], paths["2b"], 1, 0);
  animate(birds[2], paths["3b"], 1, 0);
};

const birds = () => {
  const hoverWrappers = document.querySelectorAll(".birds-hover");

  for (const wrapper of hoverWrappers) {
    const birds = createElements(wrapper);

    wrapper.addEventListener("mouseenter", () => {
      animateIn(birds);
    });

    wrapper.addEventListener("mouseleave", () => {
      animateOut(birds);
    });
  }

  const scrollWrappers = document.querySelectorAll(".birds-scroll");

  for (const wrapper of scrollWrappers) {
    const birds = createElements(wrapper);

    ScrollTrigger.create({
      trigger: wrapper,
      once: true,
      start: "top 80%",
      onEnter: () => {
        animateIn(birds);
      },
    });
  }
};

export default birds;
